import React, {Component, Fragment} from "react";
import classnames from "classnames";
import { Image, Menu, Plus, Search, Star, Check, Info, Trash, Edit, Tag } from "react-feather";
import {
  Button, Card, CardBody, Col, FormGroup, Input, Row,
  Label, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown
} from "reactstrap";

import Checkbox from "../../theme/@vuexy/checkbox/CheckboxesVuexy";
import Chip from "../../theme/@vuexy/chips/ChipComponent";

class TodoMutation extends Component {
  constructor(props){
    super(props);
    this.state={
      todo: this.props.todo,
      isEditable: this.props.isEditable
    };
  }

  toggleValue = (name) => {
    const {todo} = this.state;
    this.setState({
      todo: {...todo, [name]: !todo[name]}
    })
  }

  setTags = (name) => {
    const {todo} = this.state;
    const dump = todo.labels;
    let status = dump.includes(name);
    if (status) {
      let index = dump.findIndex(todo => todo === name);
      dump.splice(index, 1);
    } else {
      dump.push(name)
    }
    this.setState({
      todo: {...todo, labels: dump}
    })
  }

  onChange = (e) => {
    const { todo } = this.state;
    this.setState({
      todo: {...todo, [e.target.name]: e.target.value}
    }, ()=>console.log(todo))
  }

  renderTags = taskArr => {
    return taskArr.map((tag, i) => (
      <div className="chip mb-0 mr-50" key={i}>
        <div className="chip-body">
          <span className="chip-text">
            <span
              className={`bullet bullet-${
                tag === "backend"
                  ? "warning"
                  : tag === "doc"
                    ? "success"
                    : tag === "bug"
                      ? "danger"
                      : "primary"
                } bullet-xs`}
            />
            <span className="text-capitalize ml-25">{tag}</span>
          </span>
        </div>
      </div>
    ))
  }

  render() {
    const { isEditable, todo } = this.state;
    const routerFilter = "";
    return(
      <div className="animation-slider-sidebar" style={{ width: "40vw" }}>
        <div className="sidebar_header">
          <span className="heading">
            {this.state.isEditable ? "Update Todo" : "Add Todo"}
          </span>
          {/*-------------Sidebar Top Action Buttons--------------*/}
          <div>
            <Button
              className="btn mr-1"
              onClick={() => this.props.saveTodo(todo)}
              color="primary">
              {this.state.isEditable ? "Update" : "Add"}
            </Button>
            <Button
              className="btn ml-1"
              outline
              color="danger"
              onClick={this.props.closeOverlay}
            >
              Cancel
          </Button>
          </div>
        </div>
        <div className="sidebar_content">
          <div className="d-flex justify-content-between align-items-center">
            {/*-------------Sidebar Toggle Icons--------------*/}
            <div>
              {
                !isEditable
                  ? null
                  : <Checkbox
                    color="primary"
                    className="mr-1 mb-2"
                    label="Task Completed"
                    icon={<Check className="vx-icon" size={16} />}
                    id="isCompleted"
                    checked={todo.isCompleted ? true : false}
                    name="isCompleted"
                    onChange={() => this.toggleValue("isCompleted")}
                    value={todo.isCompleted}
                  />
              }
            </div>
            <div>
              <div
                className={`todo-item-info d-inline-block ${
                  routerFilter === "trashed" ? "mr-1" : "mr-1 mr-sm-0"
                  }`}
                name="isImportant"
                onClick={e => {
                  e.stopPropagation()
                  this.toggleValue("isImportant")
                }}
              >
                <Info
                  size={17}
                  color={todo.isImportant ? "#228B22" : "#333"}
                  className="ml-1"
                />
              </div>
              <div
                className="todo-item-favorite d-inline-block mr-1 mr-sm-0"
                name="isStarred"
                onClick={e => {
                  e.stopPropagation()
                  this.toggleValue("isStarred")
                }}
              >
                <Star
                  size={17}
                  color={todo.isStarred ? "#FFDF00" : "#333"}
                  className="ml-1"
                />
              </div>




              <UncontrolledDropdown className="d-inline-block ml-1">
                <DropdownToggle tag="span">
                  <Tag size={18} />
                </DropdownToggle>
                <DropdownMenu tag="ul" right>
                  <DropdownItem tag="li">
                    <Checkbox
                      color="primary"
                      className="user-checkbox"
                      icon={<Check className="vx-icon" size={12} />}
                      label={"Frontend"}
                      checked={todo.labels.includes("frontend") ? true : false}
                      size="sm"
                      onChange={e => {
                        e.stopPropagation()
                        this.setTags("frontend")
                      }}
                    />
                  </DropdownItem>
                  <DropdownItem tag="li">
                    <Checkbox
                      color="primary"
                      className="user-checkbox"
                      icon={<Check className="vx-icon" size={12} />}
                      label={"Backend"}
                      checked={todo.labels.includes("backend") ? true : false}
                      size="sm"
                      onChange={e => {
                        e.stopPropagation()
                        this.setTags("backend")
                      }}
                    />
                  </DropdownItem>
                  <DropdownItem tag="li">
                    <Checkbox
                      color="primary"
                      className="user-checkbox"
                      icon={<Check className="vx-icon" size={12} />}
                      label={"Doc"}
                      checked={todo.labels.includes("doc") ? true : false}
                      size="sm"
                      onChange={e => {
                        e.stopPropagation()
                        this.setTags("doc")
                      }}
                    />
                  </DropdownItem>
                  <DropdownItem tag="li">
                    <Checkbox
                      color="primary"
                      className="user-checkbox"
                      icon={<Check className="vx-icon" size={12} />}
                      label={"Bug"}
                      checked={todo.labels.includes("bug") ? true : false}
                      size="sm"
                      onChange={e => {
                        e.stopPropagation()
                        this.setTags("bug")
                      }}
                    />
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>





            </div>
          </div>
          {/*-------------Sidebar Form--------------*/}
          <FormGroup>
            <Label htmlFor="todo_title">Title</Label>
            <Input
              type="text"
              value={todo.title}
              name="title"
              placeholder="Title"
              onChange={e => this.onChange(e)}
              id="todo_title"
            />
          </FormGroup>
          <FormGroup>
            <Label htmlFor="todo_description">Description</Label>
            <Input
              type="text"
              value={todo.description}
              name="description"
              placeholder="Description"
              onChange={e => this.onChange(e)}
              id="todo_description"
            />
          </FormGroup>
          <div className="chip-wrapper my-1 d-flex flex-wrap">
            {
              todo.labels.length
                ? this.renderTags(todo.labels)
                : null
            }
          </div>
        </div>
      </div>
    );
  }
}

export default TodoMutation;